/**
 * @returns true if plan is subscription based.
 */
export const isRecurringPlan = plan => {
  var _plan$pricing;
  return Boolean((_plan$pricing = plan.pricing) == null ? void 0 : _plan$pricing.subscription);
};
//# sourceMappingURL=is-recurring-plan.js.map